import React from 'react'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react';
import useCsrfToken from '../hooks/useCsrfToken';

export default function Blogpaginated() {
    const { csrfToken } = useCsrfToken();
    const [listings, setListings] = useState([]);
    const [tags, setTags] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const API_URL = process.env.REACT_APP_API_URL;

    const [totalpages, setTotalpages] = useState(1);
    const [currentpage, setCurrentpage] = useState(1);

    const transformData = (data) => {
        return data.map(item => ({
            id: item.id,
            image: `${API_URL}${item.primary_image}`,
            tag: 'Blog',
            title: item.title,
            slug: item.slug,
            desc: item.description.length > 100 ? item.description.substring(0, 100) + '...' : item.description,
            tags: item.tags,
        }));
    };

    const getDataPaginated = async (page = 1) => {
        fetch(`${API_URL}/api/listings/blog/${page}`, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'X-CSRF-TOKEN': csrfToken,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.json())
            .then(data => {
                setListings(transformData(data.data));
                setTotalpages(data.last_page);
                setCurrentpage(data.current_page);
            })
            .catch(error => console.error('Error fetching data:', error));
    }


    useEffect(() => {
        const transformData = (data) => {
            return data.map(item => ({
                id: item.id,
                image: `${API_URL}${item.primary_image}`,
                tag: 'Blog',
                title: item.title,
                slug: item.slug,
                desc: item.description.length > 100 ? item.description.substring(0, 100) + '...' : item.description,
                tags: item.tags,
            }));
        };
        if (csrfToken != null) {
            const fetchData = async () => {
                fetch(`${API_URL}/api/listings/blog/1`, {
                    method: 'GET',
                    credentials: 'include',
                    headers: {
                        'X-CSRF-TOKEN': csrfToken,
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                    }
                }).then(response => response.json())
                    .then(data => {
                        setListings(transformData(data.data));
                        setTotalpages(data.last_page);
                        setCurrentpage(data.current_page);
                        setIsLoading(false);
                        // console.log('totalpages', totalpages);
                        // console.log('currentpage', currentpage);
                    })
                    .catch(error => console.error('Error fetching data:', error));
            }
            fetch(`${API_URL}/api/filtertags`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => setTags(data))
                .catch(error => console.error('Error fetching data:', error));
            fetchData();
        }
    }, [API_URL, totalpages, csrfToken]);

    const [selectedTag, setSelectedTag] = useState('');
    const [searchTerm, setSearchTerm] = useState('');


    const handleTagChange = (event) => {
        setSelectedTag(event.target.value);
    };
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredServices = listings.filter(item => {
        const matchesTag = selectedTag ? item.tags.some(tg => tg.pivot.tag_id === parseInt(selectedTag)) : true;
        const matchesSearchTerm = item.title.toLowerCase().includes(searchTerm.toLowerCase()) || item.desc.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesTag && matchesSearchTerm;
    });
    return (
        <>
            <div className="row justify-content-center bg-inverted py-2">
                <div className="col-12 col-md-3">
                    <select name="specialties" className='form-control' onChange={handleTagChange}>
                        <option value="">Filtrar por área o especialidad</option>
                        <option value="">-Todo-</option>
                        {tags.map((tg, index) => (
                            <option key={index} value={tg.id}>{tg.title}</option>
                        ))}
                    </select>
                </div>
                <div className="col-12 col-md-3">
                    <input name="searchfield" type="text" className='form-control' placeholder='Buscar...' onChange={handleSearchChange} />
                </div>
            </div>
            <div className="row">
                {filteredServices.length > 0 ? (
                    filteredServices.map((item, index) => {
                        const stripTags = (html) => {
                            let doc = new DOMParser().parseFromString(html, 'text/html');
                            return doc.body.textContent || "";
                        };
                        return (
                            <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                                <div className="blog position-relative overflow-hidden shadow rounded p-4 d-flex flex-column h-100">
                                    <div className="position-relative">
                                        <div className="blog-image position-relative overflow-hidden rounded shadow object-fit-cover">
                                            <Link to={`/blog-leer/${item.slug}`}>
                                                <img src={item.image} className="img-fluid" alt="" />
                                            </Link>
                                        </div>

                                        <div className="position-absolute top-100 start-0 translate-middle-y ms-2">
                                            <Link to="#" className="badge bg-primary">{item.tag}</Link>
                                        </div>
                                    </div>

                                    <div className="pt-4 flex-grow-1 d-flex flex-column">
                                        <Link to={`/blog-leer/${item.slug}`} className="text-dark title h5">{item.title}</Link>

                                        <p className="text-muted my-2">{stripTags(item.desc)}</p>

                                        <Link to={`/blog-leer/${item.slug}`} className="text-dark read-more">Leer más <i className="mdi mdi-chevron-right align-middle"></i></Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                ) : (
                    <div className="col-12 mt-4 pt-2 text-center">
                        {isLoading ? (
                            <p className="text-muted">Cargando...</p>
                        ) : (
                            <p className="text-muted">No hay publicaciones.</p>
                        )}
                    </div>
                )}
            </div>

            {(!selectedTag && !searchTerm) && (
                <div className="row">
                    <div className="col-12 mt-4 pt-2">
                        <ul className="pagination justify-content-center mb-0">
                            <li className={`page-item ${currentpage === 1 ? 'disabled' : ''}`}>
                                <Link className="page-link" to="#" aria-label="Previous" onClick={() => getDataPaginated(currentpage - 1)}>
                                    <span aria-hidden="true"><i className="mdi mdi-chevron-left align-middle fs-6"></i></span>
                                </Link>
                            </li>
                            {Array.from({ length: totalpages }, (_, index) => (
                                <li key={index} className={`page-item ${currentpage === index + 1 ? 'active' : ''}`}>
                                    <Link className="page-link" to="#" onClick={() => getDataPaginated(index + 1)}>{index + 1}</Link>
                                </li>
                            ))}
                            <li className={`page-item ${currentpage === totalpages ? 'disabled' : ''}`}>
                                <Link className="page-link" to="#" aria-label="Next" onClick={() => getDataPaginated(currentpage + 1)}>
                                    <span aria-hidden="true"><i className="mdi mdi-chevron-right align-middle fs-6"></i></span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            )}
        </>
    )
}
